export default {
  state: {
    addressDefault: {
      ADDRESS: '',
      CITYIDNAME: '',
      COUNTYIDNAME: '',
      ID: '',
      MOBILE: '',
      NAME: '',
      PROVINCEIDNAME: ''
    }
  },
  mutations: {
    setAddressDefault (state, addressDefault) {
      // state.addressDefault = value
      Object.assign(state.addressDefault, addressDefault)
    }
  },
  actions: {}
}
